import React from "react";
import { toast } from "react-toastify";
import { decode as base64_decode } from "base-64";
const md5 = require("md5");

export const getMessageFromApiResponse = (mensagemBase64) => {
  try {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(mensagemBase64, "text/xml");

    return atob(
      xmlDoc.getElementsByTagName("statusMessage")[0].childNodes[0].nodeValue
    );
  } catch (error) {
    return "";
  }
};

export const enterpriseUseDelivery = (id) => {
  return false; // Temporarily disabled, as per the comment in the original code
  // return (
  //   Number(id) === 6 ||
  //   Number(id) === 11 ||
  //   Number(id) === 12 ||
  //   Number(id) === 13 ||
  //   Number(id) === 14 ||
  //   Number(id) === 15 ||
  //   Number(id) === 16 ||
  //   Number(id) === 17 ||
  //   Number(id) === 18 ||
  //   Number(id) === 19 ||
  //   Number(id) === 20 ||
  //   Number(id) === 10
  // );
};

export const getUserIdFromSession = (id) => {
  if (!id) {
    toast.error(
      "Não foi possível identificar o código do usuário na sessão, faça login novamente!",
      {
        autoClose: 17000,
        icon: () => <i className="tim-icons icon-simple-remove" />,
      }
    );
  }
  return id;
};

export const getApiErrorMessage = (error, context = "") => {
  const status = error?.response?.status;
  const isTimeout = status === 504 || error?.code === "ECONNABORTED";

  if (isTimeout) {
    return "Devido a lentidão no Sankhya, não foi possível realizar a operação.";
  }

  return `Não foi possível conectar ao servidor, atualize a página e tente novamente. ${context} ${
    error?.message || ""
  }`.trim();
};

export const normalizePrecoNegociado = (precoNegociado, precoMinimo) => {
  const precoNegociadoNumber = Number(precoNegociado);
  const precoMinimoNumber = Number(precoMinimo);

  if (precoNegociadoNumber < precoMinimoNumber) {
    return precoMinimoNumber;
  }

  return precoNegociadoNumber;
};
export const getValorDescarga = ({
  AD_DESFECHADA,
  AD_DESPALET,
  AD_DESVOLUME,
  AD_VLRDESFECHADA,
  QTD_NEG,
  AD_VLRDESVOLUME,
  QTD_PALET,
  AD_VLRDESPALET,
}) => {
  if (AD_DESFECHADA == "S" && AD_DESPALET != "S" && AD_DESVOLUME != "S")
    return AD_VLRDESFECHADA;

  if (AD_DESVOLUME == "S" && AD_DESPALET != "S" && AD_DESFECHADA != "S")
    return QTD_NEG * AD_VLRDESVOLUME;

  if (AD_DESPALET == "S" && AD_DESVOLUME != "S" && AD_DESFECHADA != "S")
    return QTD_PALET * AD_VLRDESPALET;

  if (AD_DESPALET == "S" && AD_DESVOLUME == "S" && AD_DESFECHADA != "S")
    return QTD_PALET * AD_VLRDESPALET + QTD_NEG * AD_VLRDESVOLUME;

  return 0;
};

export const userCantInclude = (sector) => {
  return sector == 11 || sector == 8 || sector == 1;
};

export const userCantMakeOrder = (sector) => {
  const TIPVEND = base64_decode(sessionStorage.getItem(md5("TIPVEND")));
  return sector == 1 || TIPVEND == "R";
};

export const getAllowedEnterprises = (enterprises) => {
  if (!Array.isArray(enterprises) || enterprises.length === 0) {
    return enterprises;
  }

  try {
    const TIPVEND = base64_decode(sessionStorage.getItem(md5("TIPVEND")));
    if (TIPVEND !== "R") {
      return enterprises;
    }

    const allowEmpsEncoded = sessionStorage.getItem(md5("ALLOW_EMPS"));
    if (!allowEmpsEncoded) {
      return enterprises;
    }

    const allowEmps = JSON.parse(base64_decode(allowEmpsEncoded));
    if (!Array.isArray(allowEmps) || allowEmps.length === 0) {
      return enterprises;
    }

    return enterprises.filter((emp) =>
      allowEmps.some((allowed) => String(allowed) === String(emp.CODEMP))
    );
  } catch (error) {
    console.error("Erro ao filtrar empresas permitidas:", error);
    return enterprises;
  }
};

export const getStatusDescription = (idStatus) => {
  return StatusTypes.find((item) => item.id == idStatus);
};

export const StatusTypes = [
  { id: 0, description: "Em Preparação" },
  { id: 1, description: "Aguardando Aprovação" },
  { id: 2, description: "Aprovado" },
  { id: 3, description: "Pedido Gerado" },
  // { id: 4, description: "Pedido Faturado" },
];
